import { create } from 'zustand';
import { api } from '@/lib/api';
import { PROMPT_EVENT_TYPE } from '@visualry/shared';

type AuthState = {
  open: boolean;
  mode: 'signup' | 'signin';
  prompt: string;
  openAuth: (mode?: 'signup' | 'signin', prompt?: string, promptId?: string) => void;
  closeAuth: () => void;
};

export const useAuthModal = create<AuthState>((set) => ({
  open: false,
  mode: 'signup',
  prompt: '',
  openAuth: (mode = 'signup', prompt = '', promptId) => {
    set({ open: true, mode, prompt });
    if (mode === 'signup' && promptId) {
      void api('/api/analytics/funnel', {
        method: 'POST',
        body: { eventType: PROMPT_EVENT_TYPE.SIGNUP_CLICKED, promptId },
      }).catch(() => undefined);
    }
  },
  closeAuth: () => set({ open: false }),
}));
